import { render, staticRenderFns } from "./StockScreen3.vue?vue&type=template&id=89b149de"
import script from "./StockScreen3.vue?vue&type=script&lang=js"
export * from "./StockScreen3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports